import { memo } from 'react'
import { useTenantUserEntryContext } from '../../useTenantUserEntryDialog'
import { InviteNewUserTable } from './components/inviteNewUserTable/inviteNewUserTable'

export const InviteNewUserListPanel = memo(() => {
  const { selectedNewUsers } = useTenantUserEntryContext()
  return <InviteNewUserTable users={selectedNewUsers} />
})
